import React from 'react';
import './ChangeRequestCounter.scss';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

interface ChangeRequestCounterProps {
  counter: number | null | undefined;
}

const ChangeRequestCounter = ({ counter }: ChangeRequestCounterProps) => {
  const { t } = useTranslation();
  const showCounter = !_.isNil(counter) && counter > 0;
  return (
    <span
      style={{ display: showCounter ? 'inline-block' : 'none' }}
      className="badge change-count-badge"
      title={t('product.changeRequest.counterTooltip', {
        count: counter as number,
      })}
    >
      {counter}
    </span>
  );
};

export default ChangeRequestCounter;
